exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notice-container[data-v-23603f19] {\n  background: #444444;\n  height: 0.8rem;\n  line-height: 0.8rem;\n  color: #fff;\n}\n.notice-container[data-v-23603f19] .van-icon {\n  font-size: 0.4rem;\n}\n.notice-container .item[data-v-23603f19] {\n  padding: 0 0.266667rem;\n  font-size: 0.32rem;\n  padding-top: 0.066667rem;\n  display: inline-block;\n}\n.notice-container .item i[data-v-23603f19] {\n  color: #d9ab84;\n  font-style: normal;\n}", ""]);

// exports
